module.exports = __webpack_public_path__ + "images/emoji/oden.dd8185612a7dc7ff5b3a.png";